import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';

import Link from 'components/common/Link';
import IconButton from 'components/common/IconButton';
import IconCross from 'components/icons/IconCross';
import IconCharts from 'components/icons/IconCharts';

const styles = theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: 175,
    marginLeft: -20,
    overflow: 'hidden',
    transition: theme.transitions.create(['flex'], {
      duration: theme.transitions.duration.shortest,
    }),
    '&:first-child': {
      marginLeft: 10,
    },
    '&:hover': {
      flexShrink: 0,
      '& $link': {
        flexWrap: 'nowrap',
      },
    },
    '&:after': {
      content: '""',
      position: 'absolute',
      top: -8,
      bottom: -52,
      left: 10,
      right: 10,
      zIndex: 1,
      backgroundColor: theme.palette.primary.A100,
      transform: 'perspective(200px) rotateX(40deg)',
      boxShadow: theme.shadows[7],
    },
  },
  rootActive: {
    flexShrink: 0,
    zIndex: 200,
  },
  rootActiveVariantCharts: {
    '&:after': {
      backgroundColor: theme.palette.grey[100],
    },
  },
  rootActiveVariantPatient: {
    '&:after': {
      backgroundColor: theme.palette.common.white,
    },
  },
  rootActiveVariantPatientLoading: {
    '&:after': {
      backgroundColor: theme.palette.grey[100],
    },
  },
  link: {
    width: '100%',
    justifyContent: 'space-between',
    marginTop: 8,
    position: 'relative',
    zIndex: 2,
    flexWrap: 'wrap',
    maxWidth: '100%',
    boxSizing: 'border-box',
    height: 36,
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    color: theme.palette.grey[600],
    fontWeight: 700,
  },
  linkMain: {
    justifyContent: 'flex-start',
  },
  linkText: {
    marginTop: 11,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  linkTextMain: {
    marginLeft: 8,
  },
  buttonRemove: {
    verticalAlign: 'top',
    position: 'relative',
    zIndex: 1,
    width: 20,
    height: 20,
    margin: '7px -3px -3px 5px',
  },
  iconCross: {
    width: 11,
    height: 11,
  },
  iconCharts: {
    width: 20,
    height: 24,
    marginTop: 6,
  },
});

class PatientsTabsItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false,
    };

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  onMouseEnter() {
    this.setState({ hovered: true });
  }

  onMouseLeave() {
    this.setState({ hovered: false });
  }

  render() {
    const {
      main,
      variant,
      loading,
      active,
      href,
      children,
      onRemove,
      style,
      classes,
    } = this.props;
    const { hovered } = this.state;

    return (
      <div
        {...style ? { style } : {}}
        className={classNames(classes.root, {
          [classes.rootActive]: active,
          [classes.rootActiveVariantCharts]: active && variant === 'charts',
          [classes.rootActiveVariantPatient]:
            active && variant === 'patient' && !loading,
          [classes.rootActiveVariantPatientLoading]:
            active && variant === 'patient' && loading,
        })}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <Link
          className={classNames(classes.link, {
            [classes.linkMain]: main,
          })}
          href={href}
          size="sm"
        >
          {main &&
            <IconCharts className={classes.iconCharts} />
          }
          <span
            className={classNames(classes.linkText, {
              [classes.linkTextMain]: main,
            })}
          >
            {children}

          </span>
          {onRemove &&
            <IconButton
              className={classes.buttonRemove}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onRemove();
              }}
              tooltipContent={hovered ? 'Remove tab' : null}
            >
              <IconCross className={classes.iconCross} />
            </IconButton>
          }
        </Link>
      </div>
    );
  }
}

PatientsTabsItem.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onRemove: PropTypes.func,
  main: PropTypes.bool,
  active: PropTypes.bool,
  variant: PropTypes.oneOf(['charts', 'patient']),
  loading: PropTypes.bool,
  style: PropTypes.shape({
    zIndex: PropTypes.number,
  }),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    rootActive: PropTypes.string.isRequired,
    rootActiveVariantCharts: PropTypes.string.isRequired,
    rootActiveVariantPatient: PropTypes.string.isRequired,
    rootActiveVariantPatientLoading: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    linkMain: PropTypes.string.isRequired,
    linkText: PropTypes.string.isRequired,
    linkTextMain: PropTypes.string.isRequired,
    buttonRemove: PropTypes.string.isRequired,
    iconCross: PropTypes.string.isRequired,
    iconCharts: PropTypes.string.isRequired,
  }).isRequired,
};

PatientsTabsItem.defaultProps = {
  onRemove: null,
  main: false,
  active: false,
  variant: 'charts',
  style: null,
  loading: false,
};

export default withStyles(styles)(PatientsTabsItem);



// WEBPACK FOOTER //
// ./src/components/patient/PatientsTabs/PatientsTabsItem.js